import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import styles from "./styles.module.css";
import { EditOutlined } from "@mui/icons-material";
import { useTheme } from "../../../../../../../context/themeContext";
import CoverImageUploader from "./components/cover-image-uploader";
import UploadProjectImage from "./components/upload-profile-image";
import EditProjectImage from "./components/edit";
import DeleteProjectImage from "./components/delete";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsModalProjectOpen,
  setSelectedProjectImage,
} from "../../../../../../../store/slices/profile/projectCoverImageSlice";

const ProjectCoverImage = () => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const {
    croppedImage,
    selectedProjectImage,
    isDeleteProjectImageOpen,
    originalProjectImage,
  } = useSelector((state) => state.projectCoverImage);

  const [project_cover_image, setProjectCoverImage] = useState(croppedImage);

  useEffect(() => {
    setProjectCoverImage(croppedImage);
  }, [croppedImage]);

  useEffect(() => {
    dispatch(setSelectedProjectImage(originalProjectImage));
  }, []);

  return (
    <Box className={styles.skillsImg}>
      <Box
        className={styles.primaryImg}
        sx={{
          backgroundImage: project_cover_image
            ? `url(${project_cover_image})`
            : "none",
        }}
      >
        {!project_cover_image && <CoverImageUploader />}
        <Box className={styles.options}>
          {project_cover_image && (
            <Box
              className={styles.Cameraupload}
              onClick={() => dispatch(setIsModalProjectOpen(true))}
            >
              <EditOutlined
                fontSize="16px"
                sx={{ color: theme.palette.darkgrey.darkgrey400 }}
              />
            </Box>
          )}
        </Box>
      </Box>
      <UploadProjectImage projectCoverImage={project_cover_image} />
      {selectedProjectImage && <EditProjectImage />}
      {isDeleteProjectImageOpen && <DeleteProjectImage />}
    </Box>
  );
};

export default ProjectCoverImage;
